import { TranscriptQuote } from '../../../teams-call';

export function filterQuotesByKeyword(
    keyWord: string | null,
    quotes: TranscriptQuote[],
): TranscriptQuote[] {
    if (keyWord == null || keyWord.trim().length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return q.quote?.toLowerCase().includes(keyWord.toLowerCase());
    });
}
